export default __webpack_public_path__ + "adobe-illustrator.515ec123.png";